module.exports = __webpack_public_path__ + "media/add-ons/meetup@3x-055de17a.png";